/* eslint-disable no-unused-vars */
import { useMemo } from 'react';
import { Each, Tab } from 'components';
import * as S from './FirstThreeItems.styled';
import { TabContent } from '../tabContent/TabContent';

const tabStyle = {
  maxWidth: '30%',
  minWidth: '30%',
  width: '30%',
  height: '70px',
  textAlign: 'left',
  paddingTop: '4px',
};

export const FirstThreeItems = ({ separateCreatives$, selectedBannerId, handleCreativeChange }) => {
  return (
    <S.Container>
      <Each
        fieldOfIndex='value'
        of={separateCreatives$.value.firstThreeItems}
        render={(item, index) => {
          return (
            <Tab
              pressed={selectedBannerId === item.bn_bannerid}
              label={<TabContent {...item} />}
              onChange={() => handleCreativeChange(item.bn_bannerid)}
              style={tabStyle}
            />
          );
        }}
      />
    </S.Container>
  );
};
